import Gleap from 'gleap';
import { useDispatch, useSelector } from 'react-redux';
import { IconMap } from '../../../../shared/sprite';
import { integrationsModel } from '../../../../entities/integrations';
import { Button, Icon, Modal } from '../../../../shared/ui';

export const EnterpriseOnlyModal = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(integrationsModel.actions.setIsEnterpriseOnlyModalOpen(false));
  };

  const isOpen = useSelector(
    integrationsModel.selectors.selectIsEnterpriseOnlyModalOpen
  );

  const handleContactUs = () => {
    Gleap.open();
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      isShowCancelButton={true}
      onClose={handleClose}
      title={config.title}
      className="w-120"
      actionButton={
        <Button
          onClick={handleContactUs}
          fullWidth
          color="primary"
          variant="text"
        >
          Contact Us
        </Button>
      }
    >
      <div className="text-sm font-normal text-gray-600 mb-5">
        {config.description}
      </div>
      <div className="flex flex-col gap-4 text-sm text-gray-600 mb-5 self-center">
        {config.items.map(({ id, text }) => (
          <div className="flex flex-nowrap items-center gap-2" key={id}>
            <Icon
              glyph={IconMap.CheckCircle}
              className="text-primary-600 flex-shrink-0"
              width={20}
            />
            <p className="truncate">{text}</p>
          </div>
        ))}
      </div>
      <div className="text-sm font-normal text-gray-600">... and more!</div>
    </Modal>
  );
};

const config = {
  title: 'For Enterprise Only',
  description:
    'Standardize the Distribute experience for your organization and access enterprise-level security, admin control, and personalized support.',
  items: [
    { id: 1, text: 'App Pro plan features ' },
    { id: 2, text: 'CRM Integrations' },
    { id: 3, text: 'Customer Success Manager' },
  ],
};
